<template>
  <div>
    <!-- 表单 -->
    <el-scrollbar
      :wrap-style="scrollbarWrapStyle"
      :max-height="maxHeight"
    >
      <el-form
        ref="ruleFormDom"
        :model="formData"
        size="mini"
        style="padding-bottom: 26px"
        v-bind="formProps ? formProps : {}"
        @submit.native.prevent="confirm"
      >
        <base-form-item
          :form-data="formData"
          :default-label-width="defaultLabelWidth"
        >

          <template #custom="customProps">
            <slot name="custom" v-bind="customProps" />
          </template>
        </base-form-item>

      </el-form>
    </el-scrollbar>
    <!-- 是否显示按钮 -->
    <div
      v-if="isShowButton"
      class="form-control"
    >
      <el-button @click="cancel">
        取消
      </el-button>
      <el-button
        type="primary"
        :loading="isLoading"
        @click="confirm"
      >
        确定
      </el-button>
    </div>
  </div>
</template>

<script>
import BaseFormItem from '@/components/app-form-item';

export default {
  components: {
    BaseFormItem,
  },
  provide() {
    return {
      validateField: this.validateField,
    };
  },
  props: {
    // 表单最大高度
    maxHeight: {
      type: [Number, String],
      default: '100%',
    },
    // 表单数据
    formData: {
      type: Object,
      required: true,
    },
    // 是否显示按钮
    isShowButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    // 表单属性
    formProps: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    // 默认文本宽度
    defaultLabelWidth: {
      type: String,
      required: false,
      default: '80px',
    },
    // 提交请求
    submitRequest: {
      type: [Function, Promise],
      default: null,
    },
    // 滚动条包裹容器的自定义样式 - 样式需用 ; 作为结束/分隔
    scrollbarWrapStyle: {
      type: String,
      default: '',
    },
    // 是否在取消行为中重置表单项
    isResetUponCancel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    /**
     * 是否禁用按钮
     * @param {*} val 值
     * @param {*} check_val 绑定值
     */
    isDisabled: function(val, check_val) {
      return (typeof val === 'object' ? JSON.stringify(val) : val) !== (typeof old_val === 'object' ? JSON.stringify(check_val) : check_val);
    },
    /** 取消 */
    cancel() {
      this.isResetUponCancel && this.$refs.ruleFormDom.resetFields();
      this.$emit('cancel', false);
    },
    /**
     * 对部分表单字段进行校验
     * @param {string | string[]} props 字段名称
     * @param {Function(errorMessage: string)} callback 校验结果回调
     */
    validateField(props, callback) {
      this.$refs.ruleFormDom.validateField(props, callback);
    },
    /**
     * 确定
     * @param {boolean} is_validate 效验失败后是否格式化数据并返回效验结果
     * @param {boolean} is_filter_empty 是否过滤空值
    */
    async confirm(is_validate = true, is_filter_empty = true) {
      let is_succeed = false;

      // 表单验证
      await this.$refs.ruleFormDom.validate((valid, formRuleList) => {
        is_succeed = is_validate ? this.ruleFormTips(valid, formRuleList) : valid;
      });

      if (!is_succeed && is_validate){
        return;
      }

      const formParams = this.paramsFormat(this.formData, is_filter_empty);

      if (formParams !== null) {
        this.submitData(formParams);
      }

      if (!is_validate) {
        this.$refs.ruleFormDom.clearValidate();
        return is_succeed;
      }

      return true;
    },

    /**
     * 参数格式化
     * @param obj 参数配置对象
     * @param is_filter_empty 是否过滤空值
     */
    paramsFormat(obj, is_filter_empty = true) {
      const formParams = {};

      for (const key in obj) {
        if (obj[key]) {
          const item = obj[key];
          if (item.hidden || item.is_filter) {
            continue;
          }

          const paramsValue = item.value;
          if (
            (!is_filter_empty || paramsValue !== '') &&
            typeof paramsValue !== 'undefined' &&
            paramsValue !== null &&
            paramsValue[0] !== null
          ) {
            if (item.children) {
              formParams[key] = this.paramsFormat(item.children, is_filter_empty);
            } else {
              formParams[key] = item.value;
            }
          }
        }
      }

      return formParams;
    },

    /**
     * 提交数据
     * @param params 提交参数
     */
    submitData(params = {}) {
      this.isLoding = true;
      if (this.submitRequest) {
        if (this.submitRequest.then) {
          this.submitRequest(params).then(() => {
            this.isLoding = false;
            this.$refs.ruleFormDom.resetFields();
            this.$emit('confirm', params);
          }).catch(() => {
            this.isLoding = false;
          });
        } else {
          this.submitRequest(params);
        }
      } else {
        this.$emit('confirm', params);
        this.isLoding = false;
      }
    },

    /**
     * 表单验证提示
     * @param valid 是否有效
     * @param formRuleList 表单验证列表
     */
    ruleFormTips(valid, formRuleList) {
      if (valid) {
        return true;
      } else {
        for (const key in formRuleList) {
          if (formRuleList[key]) {
            const item = formRuleList[key][0];
            this.$message.warning(item.message);
            break;
          }
        }
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.form-control {
    margin-top: 30px;
    text-align: right;
}
</style>
